import { render } from "./role.vue?vue&type=template&id=3295ae4c"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=3295ae4c&lang=postcss"
script.render = render

export default script